import { useEffect, useState, useCallback, useMemo } from "react";
import { useEventReport } from "../redux/ReduxContext";
import { Delete12Filled, Delete16Regular, Delete20Filled } from "@fluentui/react-icons";

export interface OiDmcData {
    selectedDmcCodes: string[];
}
export default function OiDmc() {
    const { state, dispatch } = useEventReport();
    const { dataMatrixCodes } = state;


    const [isLoading, setIsLoading] = useState(false);
    const [newDmcCode, setNewDmcCode] = useState("");


    const handleAddNewDmcCode = () => {
        const trimmedDmcCode = newDmcCode.trim().toUpperCase();
        if (trimmedDmcCode) {
            dispatch({ type: 'ADD_ARRAY_ITEM', payload: { field: 'dataMatrixCodes', item: trimmedDmcCode } });
            setNewDmcCode("");
        }
    };

    const handleNewDmcCodeKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddNewDmcCode();
        }
    };

    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 mb-4 drop-shadow-md">
            <h6 >DMC Codes</h6>

            <div className="flex gap-2 w-full">
                <div className="relative w-full">
                    <input
                        type="text"
                        placeholder="ie. grain size"
                        value={newDmcCode}
                        onChange={(e) => setNewDmcCode(e.target.value)}
                        onKeyPress={handleNewDmcCodeKeyPress}
                        className="h-12 w-full p-2 pr-20 mt-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border bg-primary-light dark:bg-primary-dark border-gray-300 dark:border-gray-600 placeholder-gray-400"
                    />
                    <button
                        className="absolute right-2 top-1/2 -translate-y-1/2 px-3 py-1 bg-oi-button-blue text-primary-light mt-1 h-8 "
                        onClick={handleAddNewDmcCode}
                    >
                        Add
                    </button>
                </div>
            </div>
            {isLoading && (
                <div className="text-center py-4">
                    <p className="text-sm text-gray-500">Loading DMC codes...</p>
                </div>
            )}

            {!isLoading && (
                <div className="mt-4">
                    {dataMatrixCodes.length === 0 ? (
                        <p className="text-gray-500 text-sm">No DMC codes added yet. Add one using the input above.</p>
                    ) : (
                        <div className="flex flex-wrap gap-3">
                            {dataMatrixCodes.map((dmcCode, index) => (
                                <label
                                    key={index}
                                    className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded transition-colors"
                                >

                                    <span className="text-sm text-gray-700 dark:text-gray-300 select-none">
                                        {dmcCode}
                                    </span>
                                    <button onClick={() => { dispatch({ type: 'DELETE_ARRAY_ITEM', payload: { field: 'dataMatrixCodes', index: index } }) }}>
                                        <Delete16Regular>

                                        </Delete16Regular>
                                    </button>
                                </label>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}